import React, { useState } from "react";
import { FormattedMessage } from "react-intl";

import { Button } from "../button";
import { getArrayInSets } from "../../utils/get-array-in-sets";

import styles from "./styles.modules.scss";
import { saveContentfulItems } from "../../utils/save-contentful-items";

type ListType<T> = {
    items: T[][];
    Item: (props: T) => JSX.Element;
    columns?: number;
    perPage?: number;
    footer?: JSX.Element | null;
    header?: JSX.Element | null;
};

export const List = ({
    footer,
    header,
    Item,
    items,
    columns = 1,
    perPage = 3,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
}: ListType<any>) => {
    saveContentfulItems("list_items", items);

    const [page, setPage] = useState(1);

    const loadMore = () => setPage(page + 1);
    const lastItem = page * perPage;
    const more = lastItem < items.length;

    const slicedItems =
        columns === 1
            ? items.slice(0, lastItem)
            : getArrayInSets(items.slice(0, lastItem), columns);

    return (
        <div className={`list ${styles.list}`}>
            {header && (
                <div className={`header ${styles.header}`}>{header}</div>
            )}

            <div className={`items ${styles.items}`}>
                {columns === 1
                    ? slicedItems.map((data, index) => (
                          <div key={index} className={`row ${styles.row}`}>
                              <div
                                  className="column"
                                  style={{
                                      width: `${100 / columns}%`,
                                  }}
                              >
                                  <div className={`item ${styles.item}`}>
                                      <Item data={data} />
                                  </div>
                              </div>
                          </div>
                      ))
                    : slicedItems.map((row, index) => (
                          <div key={index} className={`row ${styles.row}`}>
                              {row.map((data) => (
                                  <div
                                      key={data.id}
                                      className="column"
                                      style={{
                                          width: `${100 / columns}%`,
                                      }}
                                  >
                                      <div className={`item ${styles.item}`}>
                                          <Item data={data} />
                                      </div>
                                  </div>
                              ))}
                          </div>
                      ))}
            </div>

            {more && (
                <div className={`load-more ${styles.loadMore}`}>
                    <Button onClick={loadMore}>
                        <span className="buttonTextWrapper">
                            <FormattedMessage id="globalText.langLoadMore" />
                        </span>
                    </Button>
                </div>
            )}

            {!more && (
                <div className={`no-more ${styles.noMore}`}>
                    <FormattedMessage
                        id="globalText.langOutOfFeed"
                        values={{
                            br: () => <br />,
                        }}
                    />
                </div>
            )}

            <div className={`footer ${styles.footer}`}>{footer}</div>
        </div>
    );
};
